var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31033 3.69416L3 4.17551V5.57145V11.9416V15.7143L3.79479 17.3104L10.7948 22.5961H10.7949L12 23.5061L13.2051 22.5961H13.2052L20.2052 17.3104L21 15.7143V13.2656V5.57145V4.17551L19.6897 3.69416L19.6896 3.69411L12.6896 1.12268H12.6895L12 0.869385L11.3105 1.12268H11.3104L4.31037 3.69411L4.31033 3.69416ZM10.6521 16.6041L18.1884 9.45057L16.8115 8L10.6521 13.8465L7.68842 11.0333L6.31152 12.4839L10.6521 16.6041Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.081efe4c3d61e82df453735af272c9bd.svg";
export { ForwardRef as ReactComponent };